import { analytics } from '../analytics';
import { BULK_UPLOAD_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

export const trackBulkUploadStarted = (properties: {
  organisation_id: string;
  is_admin: Boolean;
  is_super_admin: Boolean;
}) => {
  return analytics?.track(
    BULK_UPLOAD_EVENT_IDS.BULK_UPLOAD_STARTED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackBulkReinviteFailed = (properties: {
  organisation_id: string;
}) => {
  return analytics.track(BULK_UPLOAD_EVENT_IDS.CSV_IMPORT_FAILED, properties, {
    context: { ip: generateRandomIPAddress() },
  });
};

export const trackBulkChangesConfirmed = (properties: {
  organisation_id: string;
  is_admin: Boolean;
  is_super_admin: Boolean;
}) => {
  return analytics?.track(
    BULK_UPLOAD_EVENT_IDS.BULK_CHANGES_CONFIRMED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackBulkActivationsReviewed = (properties: {
  organisation_id: string;
  is_admin: Boolean;
  is_super_admin: Boolean;
  invite_toggle: Boolean;
}) => {
  return analytics?.track(
    BULK_UPLOAD_EVENT_IDS.BULK_ACTIVATIONS_REVIEWED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackBulkDeactivationsReviewed = (properties: {
  organisation_id: string;
  is_admin: Boolean;
  is_super_admin: Boolean;
  deactivate_toggle: Boolean;
}) => {
  return analytics?.track(
    BULK_UPLOAD_EVENT_IDS.BULK_DEACTIVATIONS_REVIEWED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackBulkChangesCancelled = (properties: {
  organisation_id: string;
  is_admin: Boolean;
  is_super_admin: Boolean;
  changes: string[];
}) => {
  return analytics.track(
    BULK_UPLOAD_EVENT_IDS.BULK_CHANGES_CANCELLED,
    {
      properties,
    },
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackBulkUploadSuccess = (properties: {
  organisation_id: string;
}) => {
  return analytics?.track(
    BULK_UPLOAD_EVENT_IDS.BULK_UPLOAD_SUCCESS,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackBulkUploadFailed = (properties: {
  organisation_id: string;
}) => {
  return analytics?.track(
    BULK_UPLOAD_EVENT_IDS.BULK_UPLOAD_FAILED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};
